import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import { reducer as formReducer } from "redux-form";

import dataReducer from "../../utils/data/dataReducer";
import enumReducer from "../../utils/enums/enumReducer";
import intlReducer from "../intl/intlReducer";
import loginReducer from "../login/loginReducer";
import memberIdentifierRecoveryReducer from "../member-identifier-recovery/memberIdentifierRecoveryReducer";
import premiumSimulatorReducer from "../dashboard/clients/client/premiumSimulator/premiumSimulatorReducer";
import salesTaxesReducer from "../dashboard/sales-taxes/salesTaxesReducer";
import accountsReducer from "../dashboard/admin/accounts/accountsReducer";
import searchReducer from "../dashboard/search/searchReducer";
import withdrawalReducer from "../withdrawal/withdrawalReducer";
import withdrawalEmailTemplateReducer from "../dashboard/clients/client/withdrawal-configuration/withdrawalEmailTemplateReducer";
import clientReducer from "../dashboard/clients/client/clientReducer";
import downloaderReducer from "../../utils/downloader/downloaderReducer";
import followUpReducer from "../dashboard/follow-ups/FollowUpReducer";
import personalDatasReducer from "../personal-data/personalDataReducer";
import selectedMembersForConfirmationType from "../dashboard/clients/client/members/SelectedMembersForConfirmationReducer";
import invoicesReducer from "../dashboard/clients/client/invoices/invoicesReducer";
import simpleFetchReducer from "../../../utils/simpleFetchReducer";

const rootReducer = combineReducers({
  auth: loginReducer,
  accounts: accountsReducer,
  data: dataReducer,
  enums: enumReducer,
  form: formReducer,
  intl: intlReducer,
  memberIdentifierRecovery: memberIdentifierRecoveryReducer,
  premiumSimulator: premiumSimulatorReducer,
  routing: routerReducer,
  search: searchReducer,
  taxes: salesTaxesReducer,
  withdrawal: withdrawalReducer,
  withdrawalEmailTemplate: withdrawalEmailTemplateReducer,
  clientActions: clientReducer,
  downloader: downloaderReducer,
  followUpActions: followUpReducer, 
  personalData: personalDatasReducer,
  selectedConfirmationMembers: selectedMembersForConfirmationType,
  invoicesRefresh: invoicesReducer,
  simpleFetch: simpleFetchReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/components/app/reducers.js